var _circle, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#0DA961"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_556_7835",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_556_7835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5487 21.575C13.4153 21.575 13.2903 21.554 13.1737 21.512C13.057 21.4707 12.9487 21.4 12.8487 21.3L8.54866 17C8.36532 16.8167 8.27766 16.579 8.28566 16.287C8.29432 15.9957 8.39032 15.7583 8.57366 15.575C8.75699 15.3917 8.99032 15.3 9.27366 15.3C9.55699 15.3 9.79032 15.3917 9.97366 15.575L13.5487 19.15L22.0237 10.675C22.207 10.4917 22.4447 10.4 22.7367 10.4C23.028 10.4 23.2653 10.4917 23.4487 10.675C23.632 10.8583 23.7237 11.0957 23.7237 11.387C23.7237 11.679 23.632 11.9167 23.4487 12.1L14.2487 21.3C14.1487 21.4 14.0403 21.4707 13.9237 21.512C13.807 21.554 13.682 21.575 13.5487 21.575Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.d118842f69eda5e70f5739617be4d986.svg";
export { ForwardRef as ReactComponent };